import { Component } from '@angular/core';

@Component({
  selector: 'app-playground-in-queued',
  standalone: true,
  imports: [],
  templateUrl: './playground-in-queued.component.html',
  styleUrl: './playground-in-queued.component.scss'
})
export class PlaygroundInQueuedComponent {

}
